module.exports = __webpack_public_path__ + "static/media/M54ws.ad009343.pdf";